import React from "react";

import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@material-ui/core";

import { withArrayNamespace } from "components/Form/FormikControls";

import { normalisePathParts } from "containers/Settings/RuleBooks/Schema/schema";

import { useFieldState } from "hooks";

import { Criterion } from "./Criterion";

export function Criteria(props) {
  const {
    namespace: ns,
    ruleInputPath,
    parentInputPath,
    showPrerequisiteRuleSource,
    readOnly,
  } = props;

  const [criteria, setCriteria] = useFieldState(ns);

  function onRemoveCriterion(index) {
    const newValue = criteria.slice();
    newValue.splice(index, 1);
    setCriteria(newValue);
  }

  return (
    <section>
      {criteria.map((ignored, i) => {
        const criteriaOptions = criteria.map(criterion =>
          normalisePathParts([
            parentInputPath,
            ruleInputPath,
            criterion.query?.value,
          ]),
        );

        const criterionInputPath = normalisePathParts([
          ruleInputPath,
          criteria[i].query?.value,
        ]);

        return (
          <fieldset key={`${i}_${criterionInputPath}`} className="p-2">
            <legend className="p-2">
              Criteria {i + 1}{" "}
              {!readOnly && (
                <IconButton
                  aria-label="delete"
                  onClick={() => onRemoveCriterion(i)}
                >
                  <FontAwesomeIcon icon={faTrash} size="xs" />
                </IconButton>
              )}
            </legend>
            <Criterion
              criteriaOptions={criteriaOptions}
              criteriaIndex={i}
              namespace={withArrayNamespace(ns, i)}
              fieldPath={criterionInputPath}
              ruleInputPath={ruleInputPath}
              parentInputPath={parentInputPath}
              showPrerequisiteRuleSource={showPrerequisiteRuleSource}
              readOnly={readOnly}
            />
          </fieldset>
        );
      })}
    </section>
  );
}
